import { css } from 'styled-components';
import { LegalAuthorizationProps } from './models';

export const LegalAuthorization = css<LegalAuthorizationProps>(({ theme }) => {
  return css`
    font-size: 10px;
    text-align: left;
    color: ${theme.colors.darkGray};

    &.healthcare {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    > .text-wrapper {
      display: flex;
      flex-direction: column;
      gap: 18px;

      > .legal-list {
        padding: 0 0 0 6px;
        margin: 0 0 0 8px;
        display: flex;
        flex-direction: column;
        gap: 18px;
      }
    }

    > .toggle-button {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: ${theme.colors.primaryBright};
      font-size: 12px;
      font-weight: 600;
    }
  `;
});
